import {
  faCheckCircle,
  faExclamationCircle,
  faQuestionCircle,
} from "@fortawesome/pro-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

export function getScanMethodInfo({
  scanMethod,
  joinExp,
  whereExp,
}: {
  scanMethod: string;
  joinExp: string | null;
  whereExp: string | null;
}): [icon: IconProp, className: string] {
  if (
    (scanMethod === "Seq Scan" || scanMethod === "Parallel Seq Scan") &&
    (whereExp !== null || joinExp !== null) // Sequential Scans with WHERE or JOIN
  ) {
    return [faExclamationCircle, "text-[#C22426]"];
  } else if (scanMethod === "Append" || scanMethod === "Merge Append") {
    return [faQuestionCircle, "text-[#777777]"];
  } else {
    // Index Scan, Index Only Scan, Bitmap Heap Scan, Tid Scan, or Sequential Scans w/o WHERE or JOIN
    return [faCheckCircle, "text-[#43962A]"];
  }
}
